/* FOM · rotulos de APRESENTACAO (Fase 1Y).

   A BASE congelada tem dois nos "Handoff …" que sao coisas DIFERENTES:

     h06           objeto de AUDITORIA do metodo — a anatomia do handoff
                   (itens 1–14), cada um com o estado real do conhecimento;
     proc-handoff  a ETAPA do fluxo ponta a ponta (cadeia ate a Operacao).

   A auditoria executiva (FOM-ARQ-0031, item 4) mostrou que um leitor de
   primeira viagem confunde os dois. A solucao autorizada e VISUAL: um rotulo
   de apresentacao — a estrutura da BASE nao muda, o dado nao muda, e o
   rotulo so existe para estes dois external_ids conhecidos. Nao e campo de
   dominio: e legenda. */

export const SELO_APRESENTACAO: Record<string, string> = {
  'h06': 'anatomia auditada',
  'proc-handoff': 'etapa do fluxo',
  /* Fase 1Z: IM/EM/IA/EA vivem como filhos de Operacional/Delivery na BASE,
     mas NAO sao departamentos — sao fluxos que atravessam a organizacao.
     A correcao autorizada e de apresentacao (FOM-ARQ-0035 §A). */
  'op-im': 'produto · fluxo',
  'op-em': 'produto · fluxo',
  'op-ia': 'produto · fluxo',
  'op-ea': 'produto · fluxo',
  /* Financeiro (d09) tambem e filho de Operacional/Delivery na BASE; o selo
     cita VERBATIM o tipo da relacao real d09 -> oper que a propria BASE
     declara — nada inventado. */
  'd09': 'suporte / escala operacional',
};

export function seloDe(externalId: string): string | null {
  return SELO_APRESENTACAO[externalId] ?? null;
}
